"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IEGridMixin = void 0;
var _inlineMediaQueryMixin = require("../inlineMediaQueryMixin");
var _spaceMixin = require("../spaceMixin");
var PROPERTY_TYPES = {
  GAP: 1,
  COLUMN: 2,
  ROW: 3
};
var IE11_PROPERTIES = {
  gridColumn: PROPERTY_TYPES.COLUMN,
  gridColumnStart: '-ms-grid-column',
  gridColumnEnd: '-ms-grid-column-span',
  gridRow: PROPERTY_TYPES.ROW,
  gridRowStart: '-ms-grid-row',
  gridRowEnd: '-ms-grid-row-span',
  gridTemplateColumns: '-ms-grid-columns',
  alignSelf: '-ms-grid-row-align',
  justifySelf: '-ms-grid-column-align',
  display: 'display',
  gap: PROPERTY_TYPES.GAP,
  columnGap: PROPERTY_TYPES.GAP,
  rowGap: PROPERTY_TYPES.GAP,
  gridGap: PROPERTY_TYPES.GAP,
  gridColumnGap: PROPERTY_TYPES.GAP,
  gridRowGap: PROPERTY_TYPES.GAP
};
var IEGridMixin = function IEGridMixin(props) {
  var isIE11 = typeof window !== 'undefined' && typeof document !== 'undefined' && !!window.MSInputMethodContext && !!document.documentMode;
  if (!isIE11) {
    return '';
  }
  var styles = [];
  Object.keys(props).forEach(function (prop) {
    var attr = IE11_PROPERTIES[prop];
    if (attr) {
      styles.push((0, _inlineMediaQueryMixin.inlineMediaQueryMixin)(prop, function (mediaProps) {
        var value = mediaProps[prop];
        if (attr === '-ms-grid-columns') {
          // IE11 uses (1fr)[12] syntax instead of repeat(12, 1fr)
          var match = value.match(/repeat\((.*?),(.*)\)/);
          if (match) {
            return attr + ": (" + match[2].trim() + ")[" + match[1].trim() + "];";
          }
          return attr + ": " + value + ";";
        }
        if (attr === '-ms-grid-column-span' || attr === '-ms-grid-row-span') {
          return attr + ": " + value.replace('span', '') + ";";
        }
        if (attr === 'display') {
          return attr + ": -ms-" + value + ";";
        }
        if (typeof attr === 'string') {
          return attr + ": " + value + ";";
        }
        if (attr === PROPERTY_TYPES.COLUMN) {
          var values = value.split('/');
          return "\n                            -ms-grid-column: " + values[0] + ";\n                            -ms-grid-column-span: " + values[1].replace('span', '') + ";\n                        ";
        }
        if (attr === PROPERTY_TYPES.ROW) {
          var _values = value.split('/');
          return "\n                            -ms-grid-row: " + _values[0] + ";\n                            -ms-grid-row-span: " + _values[1].replace('span', '') + ";\n                        ";
        }
        if (attr === PROPERTY_TYPES.GAP) {
          // Break values like `gap="xs xl"` into row and column
          var _values2 = value.split(/\s+/);
          var row = _values2[0];
          var column = _values2[1] || _values2[0];
          var gapStyles = [];
          if (!/columngap/i.test(prop)) {
            var rowSpace = (0, _spaceMixin.spaceMixin)(row)(props);
            gapStyles.push("\n                                margin-bottom: -" + rowSpace + ";\n                                & > * {\n                                    margin-bottom: " + rowSpace + ";\n                                }\n                            ");
          }
          if (!/rowgap/i.test(prop)) {
            var columnSpace = (0, _spaceMixin.spaceMixin)(column)(props);
            gapStyles.push("\n                                margin-right: -" + columnSpace + ";\n                                & > * {\n                                    margin-right: " + columnSpace + ";\n                                }\n                            ");
          }
          return gapStyles;
        }
        return '';
      })(props));
    }
  });
  return styles;
};
exports.IEGridMixin = IEGridMixin;